<div class="form-field-wrapper {{ marginBottom() }}">
  <div class="app-form-field">
    @let control = getControl();
    <mat-form-field appearance="outline">
      <mat-label>{{ label() }}</mat-label>
      <mat-chip-grid #chipGrid [formControl]="control">
        @for (item of control.value; track item) {
          <mat-chip-row (removed)="remove(item)">
            {{ item }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          [matChipInputFor]="chipGrid"
          (matChipInputTokenEnd)="add($event)"
          (blur)="addOnInputBlur($event)"
        />
      </mat-chip-grid>
    </mat-form-field>
    <app-tooltip [tooltip]="hint()"></app-tooltip>
  </div>
  <app-form-error [control]="control"></app-form-error>
</div>
